import Home from "../Pages/Home.svelte";
import NotFound from "../Pages/NotFound.svelte";
import MainLayout from "../Layouts/MainLayout.svelte";
import Dashboard from "../Pages/Dashboard.svelte";
import MyLife from "../Pages/MyLife.svelte";
import Wages from "../Pages/Wages.svelte";
import CheckIn from "../Pages/CheckIn.svelte";
import Docs from "../Pages/Docs.svelte";
import Settings from "../Pages/Settings.svelte";
import Scanning from "../Pages/Scanning.svelte";
import CheckedIn from "../Pages/QrResults/CheckedIn.svelte";
import CheckedOut from "../Pages/QrResults/CheckedOut.svelte";
import AvailabilityIndex from "../Pages/Availability/AvailabilityIndex.svelte";
import TaskCompleted from "../Pages/QrResults/TaskCompleted.svelte";
export default [
    {
        name: '/',
        component: Home
    },
    {
        name: '/home',
        component: Dashboard,
        layout: MainLayout
    },
    {
        name: '/mylife',
        component: MyLife,
        layout: MainLayout
    },
    {
        name: '/checkin',
        component: CheckIn,
        layout: MainLayout
    },
    {
        name: '/wages',
        component: Wages,
        layout: MainLayout
    },
    {
        name: '/docs',
        component: Docs,
        layout: MainLayout
    },
    {
        name: '/settings',
        component: Settings,
        layout: MainLayout
    },
    {
        name: '/scan/:qr',
        component: Scanning,
        layout: MainLayout
    },
    {
        name: '/qr/checkedin',
        component: CheckedIn,
        layout: MainLayout
    },
    {
        name: '/qr/checkedout',
        component: CheckedOut,
        layout: MainLayout
    },
    {
        name: '/qr/tasked',
        component: TaskCompleted,
        layout: MainLayout
    },
    {
        name: '/availability',
        layout: MainLayout,
        nestedRoutes: [
            { name: 'index', component: AvailabilityIndex },
        ]
    },
    // ..
    {
        name: '404',
        path: '404',
        component: NotFound
    }
];
